/* ============================================================
   Shop the Videos — shared engine for both variants.
   - Cinema: an inline vertical player + desktop creator/up-next rail.
   - Wall: a contact-sheet grid that launches the immersive viewer.
   Both share: the player renderer, autoplay/progress, save, keyboard
   nav, the fullscreen viewer, and a shoppable product tray that routes
   adds through window.CartAPI (multi-variant → shared ui-sheet picker).
   ============================================================ */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }
  function selEsc(v) { return String(v).replace(/["\\]/g, '\\$&'); }
  function pad(n) { return String(n).padStart(2, '0'); }

  function cartAdd(items) {
    if (!items || !items.length) return Promise.resolve();
    if (window.CartAPI && typeof window.CartAPI.addItems === 'function') return window.CartAPI.addItems(items);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:item-added', { detail: {} })); });
  }
  function deriveOptions(prod) {
    var names = prod.optionNames || [];
    return names.map(function (name, idx) {
      var seen = {}, values = [];
      (prod.variants || []).forEach(function (v) { var val = v.options[idx]; if (val != null && !seen[val]) { seen[val] = 1; values.push(val); } });
      return { name: name, values: values, idx: idx };
    });
  }
  function valueAvailable(prod, idx, value, chosen) {
    return prod.variants.some(function (v) {
      if (!v.available) return false;
      if (String(v.options[idx]) !== String(value)) return false;
      for (var k = 0; k < chosen.length; k++) { if (k === idx) continue; if (chosen[k] != null && String(v.options[k]) !== String(chosen[k])) return false; }
      return true;
    });
  }
  function resolveVariant(prod, chosen) {
    if (chosen.some(function (c) { return c == null; })) return null;
    var match = null;
    prod.variants.some(function (v) { var ok = chosen.every(function (c, k) { return String(v.options[k]) === String(c); }); if (ok) { match = v; return true; } return false; });
    return match;
  }
  function isColorOpt(name) { return /colou?r/i.test(name || ''); }
  function swatchHex(name) {
    try { if (window.UntamedColorSwatches && window.UntamedColorSwatches.resolve) { var hex = window.UntamedColorSwatches.resolve(name); if (hex) return hex; } } catch (e) {}
    var n = String(name || '').trim().toLowerCase().replace(/\s+/g, '');
    return /^[a-z]+$/.test(n) ? n : '';
  }

  var ICON = {
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    expand: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H3v5M16 3h5v5M21 16v5h-5M3 16v5h5"/></svg>',
    bookmark: function (on) { return '<svg viewBox="0 0 24 24" fill="' + (on ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M6 4h12v16l-6-4-6 4z"/></svg>'; }
  };

  function init(section) {
    if (section.__stvInit) return;
    section.__stvInit = true;

    var variant = section.getAttribute('data-stv-variant') || 'cinema';
    var sheetId = section.getAttribute('data-stv-sheet');
    var DUR = parseInt(section.getAttribute('data-stv-duration'), 10) || 6500;
    var autoplay = section.getAttribute('data-stv-autoplay') !== 'false';
    var moneyFormat = section.getAttribute('data-stv-money') || window.themeMoneyFormat || '${{amount}}';
    var followLabel = section.getAttribute('data-stv-lbl-follow') || 'Follow';
    var addLabel = section.getAttribute('data-stv-lbl-add') || 'Add to bag';
    var inReelLabel = section.getAttribute('data-stv-lbl-inreel') || 'In this reel';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var reels = [].slice.call(section.querySelectorAll('[data-stv-reel]')).map(function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }).filter(Boolean);
    if (!reels.length) return;

    function money(c) { if (typeof window.formatMoney === 'function') { try { return window.formatMoney(c, moneyFormat); } catch (e) {} } return '$' + ((parseInt(c, 10) || 0) / 100).toFixed(2); }

    var inlinePlayer = section.querySelector('[data-stv-player]');
    var fs = section.querySelector('[data-stv-fs]');
    var fsPlayer = fs && fs.querySelector('[data-stv-fs-player]');
    var fsCount = fs && fs.querySelector('[data-stv-fscount]');

    var state = { active: 0, playing: autoplay && !reduce, prog: 0, full: false, saved: {} };
    var raf = null, vidEl = null, fillEl = null;

    function R() { return reels[state.active]; }

    /* ---- player markup ---- */
    function trayHTML(reel) {
      return '<div class="reels__tray" data-stv-tray>' + (reel.products || []).map(function (p, i) {
        return '<button type="button" class="reels__pcard" data-stv-padd data-pi="' + i + '">' +
          (p.image ? '<img class="reels__pfig" src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span class="reels__pfig"></span>') +
          '<span class="reels__pmeta"><span class="reels__pname">' + esc(p.title) + '</span>' +
          '<span class="reels__pprice mono-num">' + esc(p.priceMoney || money(p.price)) + '</span></span>' +
          '<span class="reels__pplus">' + ICON.plus + '</span></button>';
      }).join('') + '</div>';
    }
    function playerHTML(isFull) {
      var reel = R();
      var media = reel.video
        ? '<video class="reels__vid" data-stv-vid src="' + esc(reel.video) + '"' + (reel.poster ? ' poster="' + esc(reel.poster) + '"' : '') + ' muted loop playsinline preload="metadata"></video>'
        : (reel.poster ? '<img class="reels__vid" data-stv-vid src="' + esc(reel.poster) + '" alt="">' : '<span class="reels__vid" data-stv-vid></span>');
      var segs = reels.map(function (_, i) {
        var w = i < state.active ? '100%' : (i === state.active ? state.prog + '%' : '0%');
        return '<div class="reels__seg" data-stv-seg="' + i + '"><div class="reels__segfill"' + (i === state.active ? ' data-stv-fill' : '') + ' style="width:' + w + '"></div></div>';
      }).join('');
      var pcount = (reel.products || []).length;
      return '<div class="reels__player' + (isFull ? ' reels__player--full' : '') + '" data-stv-stage>' +
        media + '<div class="reels__scrim"></div>' +
        '<div class="reels__progress">' + segs + '</div>' +
        '<div class="reels__top"><span class="reels__handle"><span class="reels__av"' + (reel.avatar ? ' style="background-image:url(' + esc(reel.avatar) + ')"' : '') + '></span>' +
        '<span>@' + esc(reel.handle) + '</span>' + (reel.followUrl ? '<a class="reels__follow" href="' + esc(reel.followUrl) + '">' + esc(followLabel) + '</a>' : '<span class="reels__follow" data-stv-follow>' + esc(followLabel) + '</span>') + '</span>' +
        (reel.duration ? '<span class="reels__dur mono-num">' + esc(reel.duration) + '</span>' : '') + '</div>' +
        '<button type="button" class="reels__save' + (state.saved[state.active] ? ' on' : '') + '" data-stv-save aria-label="Save reel">' + ICON.bookmark(!!state.saved[state.active]) + '</button>' +
        (isFull ? '' : '<button type="button" class="reels__expand" data-stv-expand aria-label="Open full screen">' + ICON.expand + '</button>') +
        '<div class="reels__playbtn" data-stv-playbtn' + (state.playing ? ' hidden' : '') + '>' + ICON.play + '</div>' +
        '<div class="reels__bottom"><div class="reels__capline"><span class="reels__caphandle">@' + esc(reel.handle) + '</span><span class="reels__cap">' + esc(reel.caption) + '</span></div>' +
        (pcount ? '<div class="reels__shoprow"><span class="reels__shopn label">' + esc(inReelLabel) + ' · ' + pcount + ' ' + (pcount > 1 ? 'pieces' : 'piece') + '</span></div>' + trayHTML(reel) : '') +
        '</div></div>';
    }

    function paintInto(container, isFull) {
      if (!container) return;
      container.innerHTML = playerHTML(isFull);
      vidEl = container.querySelector('[data-stv-vid]');
      fillEl = container.querySelector('[data-stv-fill]');
      if (vidEl && vidEl.tagName === 'VIDEO') {
        if (state.playing) { var pr = vidEl.play(); if (pr && pr.catch) pr.catch(function () {}); } else { vidEl.pause(); }
      }
    }
    function render() {
      paintInto(state.full && fsPlayer ? fsPlayer : inlinePlayer, !!(state.full && fsPlayer));
      if (state.full && fsPlayer && inlinePlayer) { /* keep inline static while full */ }
      updateRail();
      section.querySelectorAll('[data-stv-playpause]').forEach(function (b) { b.innerHTML = state.playing ? ICON.pause : ICON.play; });
      if (fsCount) fsCount.textContent = pad(state.active + 1) + ' / ' + pad(reels.length);
    }

    /* ---- autoplay / progress ---- */
    function frame(t) {
      if (!state.playing) { raf = null; return; }
      if (!frame.start) frame.start = t - (state.prog / 100) * DUR;
      var p = Math.min(100, ((t - frame.start) / DUR) * 100);
      state.prog = p;
      if (fillEl) fillEl.style.width = p + '%';
      if (vidEl && vidEl.tagName !== 'VIDEO') { vidEl.style.transform = 'scale(' + (1 + (p / 100) * 0.06) + ')'; }
      if (p >= 100) { frame.start = 0; go(1); return; }
      raf = requestAnimationFrame(frame);
    }
    function startLoop() { if (reduce) return; cancelAnimationFrame(raf); frame.start = 0; raf = requestAnimationFrame(frame); }
    function stopLoop() { cancelAnimationFrame(raf); raf = null; }

    function setActive(i) { state.active = (i + reels.length) % reels.length; state.prog = 0; render(); if (state.playing) startLoop(); }
    function go(d) { setActive(state.active + d); }
    function setPlaying(p) {
      state.playing = p;
      var btn = section.querySelectorAll('[data-stv-playbtn]'); btn.forEach(function (b) { b.hidden = p; });
      section.querySelectorAll('[data-stv-playpause]').forEach(function (b) { b.innerHTML = p ? ICON.pause : ICON.play; });
      if (vidEl && vidEl.tagName === 'VIDEO') { if (p) { var pr = vidEl.play(); if (pr && pr.catch) pr.catch(function () {}); } else vidEl.pause(); }
      if (p) startLoop(); else stopLoop();
    }
    function toggleSave() {
      state.saved[state.active] = !state.saved[state.active];
      section.querySelectorAll('[data-stv-save]').forEach(function (b) { b.classList.toggle('on', !!state.saved[state.active]); b.innerHTML = ICON.bookmark(!!state.saved[state.active]); });
    }

    /* ---- cinema up-next rail ---- */
    function updateRail() {
      section.querySelectorAll('[data-stv-qitem]').forEach(function (q) { q.classList.toggle('active', q.getAttribute('data-stv-qitem') === String(state.active)); });
      var creator = section.querySelector('[data-stv-creator]');
      if (creator) {
        var r = R();
        var nm = creator.querySelector('[data-stv-cname]'); if (nm) nm.textContent = '@' + r.handle;
        var cp = creator.querySelector('[data-stv-ccap]'); if (cp) cp.textContent = r.caption;
        var av = creator.querySelector('[data-stv-cav]'); if (av && r.avatar) av.style.backgroundImage = 'url(' + r.avatar + ')';
        creator.classList.remove('reels__swap'); void creator.offsetWidth; creator.classList.add('reels__swap');
      }
      var cstate = section.querySelector('[data-stv-cstate]'); if (cstate) cstate.textContent = pad(state.active + 1) + ' / ' + pad(reels.length);
    }

    /* ---- fullscreen ---- */
    var bodyOverflow = '';
    function openFull(i) {
      if (!fs) { return; }
      if (typeof i === 'number') state.active = i;
      state.prog = 0; state.full = true;
      fs.hidden = false;
      bodyOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      render(); setPlaying(true);
    }
    function closeFull() {
      if (!fs) return;
      state.full = false; fs.hidden = true; document.body.style.overflow = bodyOverflow;
      render(); if (state.playing) startLoop();
    }

    /* ---- product add ---- */
    function addProduct(p, btn) {
      var d = Object.assign({}, p); d.options = deriveOptions(d);
      if ((d.variants || []).length <= 1) {
        if (!d.defaultVariantId) return;
        if (btn) btn.disabled = true;
        cartAdd([{ id: d.defaultVariantId, quantity: 1 }]).then(function () { if (btn) btn.disabled = false; }).catch(function () { if (btn) btn.disabled = false; });
        return;
      }
      openSheet(d);
    }
    function openSheet(prod) {
      var sheetEl = sheetId ? document.querySelector('[data-ui-sheet="' + selEsc(sheetId) + '"]') : null;
      var body = sheetEl ? sheetEl.querySelector('[data-stv-sheet-body]') : null;
      if (!body || !window.UISheet) { cartAdd([{ id: prod.defaultVariantId, quantity: 1 }]); return; }
      var chosen = prod.options.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
      function ready() { return !!resolveVariant(prod, chosen); }
      function draw() {
        var VP = (window.UntamedSheets && window.UntamedSheets.vp) || {};
        body.innerHTML = window.UntamedSheets.renderVariantPicker([{
          pi: 0, title: prod.title, image: prod.image,
          options: prod.options.map(function (o) {
            var color = isColorOpt(o.name);
            return {
              name: o.name, oi: o.idx, isColor: color,
              selected: color ? chosen[o.idx] : null,
              values: o.values.map(function (val) {
                return { value: val, selected: String(chosen[o.idx]) === String(val), available: valueAvailable(prod, o.idx, val, chosen), hex: color ? swatchHex(val) : null };
              })
            };
          })
        }], {
          addAttr: 'data-stv-sheet-add',
          addLabel: VP.add || addLabel,
          selectLabel: VP.select || 'Select options',
          ready: ready()
        });
        body.querySelectorAll('[data-vp-val]').forEach(function (b) {
          b.addEventListener('click', function () { if (b.getAttribute('aria-disabled') === 'true') return; var oi = +b.getAttribute('data-vp-oi'), val = b.getAttribute('data-vp-val'); chosen[oi] = String(chosen[oi]) === String(val) ? null : val; draw(); });
        });
        var add = body.querySelector('[data-stv-sheet-add]');
        if (add) add.addEventListener('click', function () { var v = resolveVariant(prod, chosen); if (!v) return; add.disabled = true; cartAdd([{ id: v.id, quantity: 1 }]).then(function () { window.UISheet.close(); }).catch(function () { add.disabled = false; }); });
      }
      draw();
      window.UISheet.open(sheetId, { title: 'Choose your options' });
    }

    /* ---- events (delegated) ---- */
    section.addEventListener('click', function (e) {
      var padd = e.target.closest('[data-stv-padd]');
      if (padd) { e.preventDefault(); e.stopPropagation(); var reel = R(); addProduct(reel.products[+padd.getAttribute('data-pi')], padd); return; }
      if (e.target.closest('[data-stv-save]')) { e.preventDefault(); e.stopPropagation(); toggleSave(); return; }
      if (e.target.closest('[data-stv-follow]')) { e.preventDefault(); e.stopPropagation(); return; }
      if (e.target.closest('[data-stv-expand]')) { e.preventDefault(); e.stopPropagation(); openFull(); return; }
      if (e.target.closest('[data-stv-fs-close]')) { e.preventDefault(); closeFull(); return; }
      if (e.target.closest('[data-stv-prev]')) { e.preventDefault(); go(-1); return; }
      if (e.target.closest('[data-stv-next]')) { e.preventDefault(); go(1); return; }
      if (e.target.closest('[data-stv-playpause]')) { e.preventDefault(); setPlaying(!state.playing); return; }
      var seg = e.target.closest('[data-stv-seg]'); if (seg) { e.preventDefault(); e.stopPropagation(); setActive(+seg.getAttribute('data-stv-seg')); return; }
      var q = e.target.closest('[data-stv-qitem]'); if (q) { e.preventDefault(); setActive(+q.getAttribute('data-stv-qitem')); return; }
      var card = e.target.closest('[data-stv-card]'); if (card) { e.preventDefault(); openFull(+card.getAttribute('data-stv-card')); return; }
      // click on inline player toggles fullscreen; click on fs player toggles play
      if (e.target.closest('[data-stv-fs-player] [data-stv-stage]')) { setPlaying(!state.playing); return; }
      if (e.target.closest('[data-stv-player] [data-stv-stage]')) { openFull(); return; }
    });

    if (fs) fs.addEventListener('click', function (e) { if (e.target === fs) closeFull(); });
    document.addEventListener('keydown', function (e) {
      if (!state.full) return;
      if (e.key === 'Escape') closeFull();
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') go(-1);
      else if (e.key === ' ') { e.preventDefault(); setPlaying(!state.playing); }
    });

    // pause autoplay when the section scrolls out of view (perf + sanity)
    if ('IntersectionObserver' in window && inlinePlayer) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (state.full) return; if (en.isIntersecting) { if (autoplay && !reduce && !state.playing) setPlaying(true); } else if (state.playing) setPlaying(false); });
      }, { threshold: 0.25 }).observe(inlinePlayer);
    }

    render();
    if (state.playing) startLoop();
  }

  function boot() { document.querySelectorAll('[data-stv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
